<template>
	<el-dialog
		:close-on-click-modal="false"
		v-loading="loading"
		width="500px"
		title="维修审核"
		append-to-body
		:visible.sync="dialogFormVisible"
	>
		<el-form
			:model="ruleForm"
			size="mini"
			status-icon
			:rules="rules"
			ref="ruleForm"
			label-width="100px"
			class="demo-ruleForm"
		>
			<!-- <el-form-item label="渠道类型：">
				{{ form.name }}
			</el-form-item>
			<el-form-item label="维修单号：">
				{{ form.phone }}
			</el-form-item>
			<el-form-item label="创建日期：">
				{{ form.imei }}
			</el-form-item>
			<el-form-item label="维修大类：">
				{{ form.product }}
			</el-form-item>
			<el-form-item label="维修小类：">
				{{ form.brand }}
			</el-form-item>
			<el-form-item label="故障类型：">
				{{ form.model }}
			</el-form-item>
			<el-form-item label="产品品牌：">
				{{ form.model }}
			</el-form-item>
			<el-form-item label="产品年限：">
				{{ form.model }}
			</el-form-item>
			<el-form-item label="产品型号：">
				{{ form.model }}
			</el-form-item> -->
			<el-form-item label="审核结果：" prop="isApprove">
				<el-radio-group v-model="ruleForm.isApprove">
					<el-radio :label="1">通过</el-radio>
					<el-radio :label="2">驳回</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="备注：" prop="auditRemark">
				<el-input
					type="textarea"
					placeholder="请输入内容"
					v-model="ruleForm.auditRemark"
				>
				</el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取消</el-button>
			<el-button type="primary" @click="saveData(2)">确定</el-button>
			<!-- <el-button type="danger" @click="saveData(3)">审核不通过</el-button> -->
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			dialogFormVisible: false,
			form: {
				brand: "", // 品牌
				imei: "",
				model: "", // 型号
				name: "", // 姓名
				phone: "", // 联系方式
				precheckId: "", // 预审单id
				product: "", // 订购产品
				status: "", //
			},
			pkFacilityRepairOrderId: "",
			ruleForm: {
				pkFacilityRepairOrderId: "",
				isApprove: "",
				auditRemark: "",
			},
			rules: {
				isApprove: [
					{
						required: true,
						message: "请选择审核结果",
						trigger: ["change"],
					},
				],
			},
		};
	},
	created() {},
	methods: {
		/**
		 * 获取详情
		 */
		getInfo(id) {
			const vm = this;
			let postData = {
				precheckId: id,
			};
			vm.loading = true;
			this.$http
				.post(`/precheck/view`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						for (let key in vm.form) {
							vm.form[key] = response.data.body[key];
						}
					} else {
						vm.$message.warning(response.data.header.msg);
					}
					vm.loading = false;
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
					vm.loading = false;
				});
		},
		/**
		 * 格式化
		 */
		initData(id) {
			// for (let key in this.form) {
			// 	this.form[key] = "";
			// }
			// this.ruleForm.auditRemark = "";
			this.ruleForm.pkFacilityRepairOrderId = id;
			this.pkFacilityRepairOrderId = id;
			// this.getInfo(id);
		},
		/**
		 * 保存或更新
		 */
		saveData(status) {
			const vm = this;
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					var postData = {
						// precheckId: this.ruleForm.id,
						// status: status,
						// auditRemark: this.ruleForm.auditRemark,
						...this.ruleForm,
						isApprove: this.ruleForm.isApprove == 1 ? true : false,
					};
					vm.loading = true;
					this.$http
						.post("/facilityRepairOrder/auditRepairOrder", postData)
						.then(function (response) {
							if (response.data.header.code == "A1000") {
								vm.dialogFormVisible = false;
								vm.$message.success(response.data.header.msg);
								vm.$emit("change");
							} else {
								vm.$message.warning(response.data.header.msg);
							}
							vm.loading = false;
						})
						.catch(function (error) {
							vm.$message.error("网络错误");
							vm.loading = false;
						});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped type="text/css"></style>
